var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "top-end",
      "visible-arrow": false,
      "trigger": "hover"
    },
    on: {
      "show": _vm.show,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "arrangement-info-tooltip-wpr"
  }, [_c('table', {
    staticClass: "table text-center arrangement-info"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-hd"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "80"
    }
  }, [_vm._v("阶段")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "200"
    }
  }, [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.baseData), function(item, index) {
    return _c('tr', {
      staticClass: "border-row"
    }, [_c('td', {
      staticClass: "text-td"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('td', {
      staticClass: "text-td"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "state-name"
  }, [_vm._v(_vm._s(_vm.stateName))]), _c('i', {
    staticClass: "el-icon-my-tishi color-warning"
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfdbefe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/arrangeTooltips.vue
// module id = null
// module chunks = 